import React from 'react';

interface LogoProps {
  className?: string;
}

/**
 * Brand mark: an AR monogram inside a slowly rotating circular-type seal,
 * beside the wordmark in Le Murmure. The seal spin is the looped animation
 * (16s linear, disabled under prefers-reduced-motion via .logo-seal-spin).
 */
const Logo: React.FC<LogoProps> = ({ className = '' }) => (
  <span
    className={`inline-flex items-center gap-2.5 ${className}`}
    role='img'
    aria-label='Akash Roy'
  >
    <svg viewBox='0 0 48 48' className='h-[1.9em] w-[1.9em] shrink-0' aria-hidden='true'>
      <defs>
        <path
          id='logo-arc'
          d='M 24 5.5 A 18.5 18.5 0 1 1 23.99 5.5'
          fill='none'
        />
      </defs>
      <g className='logo-seal-spin'>
        <text fill='currentColor' className='logo-seal-text'>
          <textPath href='#logo-arc'>AKASH ROY · AKASH ROY ·</textPath>
        </text>
      </g>
      <text
        x='24'
        y='25'
        textAnchor='middle'
        dominantBaseline='central'
        fill='currentColor'
        className='logo-seal-monogram'
      >
        AR
      </text>
    </svg>
    <span className='lk lk-murmure text-[1.5em]'>
      Akash Roy<span className='text-accent'>.</span>
    </span>
  </span>
);

export default Logo;
